import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-1bb98fc0"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_swiper_slide = _resolveComponent("swiper-slide");

  var _component_swiper = _resolveComponent("swiper");

  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_swiper, {
    class: "swiper_container",
    autoplay: _ctx.swiper_option.autoplay,
    loop: _ctx.swiper_option.loop,
    speed: _ctx.swiper_option.speed,
    pagination: {
      clickable: true
    },
    modules: _ctx.modules,
    effect: "fade",
    ref: "swiperRef"
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bannerList, function (item) {
        return _openBlock(), _createBlock(_component_swiper_slide, {
          key: item.id
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("img", {
              src: item.imageUrl,
              class: "swiper_img"
            }, null, 8, _hoisted_1), _renderSlot(_ctx.$slots, "default", {}, undefined, true)];
          }),
          _: 2
        }, 1024);
      }), 128))];
    }),
    _: 3
  }, 8, ["autoplay", "loop", "speed", "modules"])]);
}